/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Seat_PredatorInputs */



/**
* | output |
* | --- |
* | "Predator" |
*
* @param {Tournament_Seat_PredatorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_seat_predator = /** @type {((inputs?: Tournament_Seat_PredatorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Seat_PredatorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prédateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Depredador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Predador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Predatore")
	return /** @type {LocalizedString} */ ("Predator")
});